function isMobileDevice() {
  // Some iPadOS versions report platform as 'MacIntel' but have touch support.
  // Treat those as mobile as well so iPad/iPad Pro behave consistently.
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints && navigator.maxTouchPoints > 1) return true;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

// Detect iPad / iPadOS (covers iPad Pro which on newer iPadOS reports as MacIntel)
function isIpadPro() {
  // iPad in older UA strings
  if (/iPad/.test(navigator.userAgent)) return true;
  // iPadOS 13+ reports as MacIntel but has touch points > 1
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints && navigator.maxTouchPoints > 1) return true;
  return false;
}

// Parse frame query param (supports frame, frame3, frame4...) to jump to a specific slide when landing from a link
const frameSearchParams = new URLSearchParams(window.location.search);
function getInitialSlideFromFrameParam() {
  // 1) Explicit ?frame=5
  if (frameSearchParams.has('frame')) {
    const raw = (frameSearchParams.get('frame') || '').trim();
    const num = parseInt(raw === '' ? '3' : raw, 10);
    if (!Number.isNaN(num)) return Math.max(0, num - 1);
  }

  // 2) Shorthand keys like ?frame3 or ?frame5 (value optional)
  for (const [key, val] of frameSearchParams.entries()) {
    const match = key.match(/^frame(\d+)$/i);
    if (!match) continue;
    const fallbackNum = parseInt(match[1], 10); // number from the key itself
    // If value is empty, use the number from the key; else parse value
    const parsed = val && val.trim() !== '' ? parseInt(val, 10) : fallbackNum;
    if (Number.isNaN(parsed)) continue;
    return Math.max(0, parsed - 1);
  }

  return null;
}

function checkRotateScreen() {
  // - On PC: never show the rotate overlay
  // - On Mobile: show .layer-rotate only when device is in landscape (except iPad/iPadOS)
  if (!isMobileDevice()) {
    $('.layer-rotate').hide();
    return;
  }

  const isLandscape = window.matchMedia && window.matchMedia('(orientation: landscape)').matches
    ? true
    : window.innerWidth > window.innerHeight;

  if (isLandscape && !isIpadPro()) {
    $('.layer-rotate').show();
  } else {
    $('.layer-rotate').hide();
  }
}

$(function () {
  checkRotateScreen();

  // Debounced resize/orientation handler to avoid thrash on rapid changes
  let resizeTimer = null;
  function debouncedCheck() {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      checkRotateScreen();
      resizeTimer = null;
    }, 120);
  }

  window.addEventListener('resize', debouncedCheck, { passive: true });
  window.addEventListener('orientationchange', debouncedCheck, { passive: true });

  // Special: on iPad Pro (iPad / iPadOS) reload after rotating, so orientation-specific layout reloads fresh.
  if (isIpadPro()) {
    function currentOrientation() {
      if (window.matchMedia && window.matchMedia('(orientation: portrait)').matches) return 'portrait';
      if (window.matchMedia && window.matchMedia('(orientation: landscape)').matches) return 'landscape';
      return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
    }
    let lastOrientation = currentOrientation();
    let ipadReloadTimer = null;
    function handleIpadOrientationChange() {
      const current = currentOrientation();
      if (current === lastOrientation) return; // no change
      lastOrientation = current;
      if (ipadReloadTimer) clearTimeout(ipadReloadTimer);
      ipadReloadTimer = setTimeout(() => location.reload(), 200);
    }
    window.addEventListener('orientationchange', handleIpadOrientationChange, { passive: true });
    window.addEventListener('resize', handleIpadOrientationChange, { passive: true });
  }
});

// ===== Swiper setup =====
let swiper;

function isMobileMainFlow() {
  return window.matchMedia('(max-width: 768px)').matches;
}

let activeCombinedFrame = 'frame3';

function getCombinedFrameIframe() {
  return document.querySelector('iframe.embedded-frame3');
}

function updateCombinedFrameHeight(frame) {
  const iframe = getCombinedFrameIframe();
  if (iframe) iframe.classList.toggle('is-frame4', frame === 'frame4');
}

function showCombinedFrame(frame) {
  activeCombinedFrame = frame === 'frame4' ? 'frame4' : 'frame3';
  updateCombinedFrameHeight(activeCombinedFrame);

  const iframe = getCombinedFrameIframe();
  if (iframe && iframe.contentWindow) {
    iframe.contentWindow.postMessage({ type: 'combined-frame-show', frame: activeCombinedFrame }, '*');
  }
}

function isCombinedFrameSource(source) {
  const iframe = getCombinedFrameIframe();
  return Boolean(iframe && iframe.contentWindow === source);
}

function bindCombinedFrameLoad() {
  const iframe = getCombinedFrameIframe();
  if (!iframe || iframe.dataset.combinedFrameLoadBound) return;

  iframe.dataset.combinedFrameLoadBound = '1';
  iframe.addEventListener('load', () => showCombinedFrame(activeCombinedFrame));
}

function scrollMobileToCombinedFrame(frame) {
  const iframe = getCombinedFrameIframe();
  if (!iframe) return;

  const rect = iframe.getBoundingClientRect();
  const scale = rect.width / 768;
  const panelOffset = frame === 'frame4' ? 1000 * scale : 0;
  window.scrollTo({
    top: Math.max(0, rect.top + window.scrollY + panelOffset),
    behavior: 'smooth',
  });
}

function initMainSwiper(retry = 0) {
  if ($('#MS__wrapper.iframe').length > 0) return;
  // Mobile dùng document flow bình thường; không khởi tạo Swiper.
  if (isMobileMainFlow()) return;
  // Prevent duplicate initialization
  if (swiper) return;
  if (typeof window.Swiper === 'undefined') {
    if (retry < 20) { // thử lại tối đa 20 lần (2s)
      setTimeout(function () { initMainSwiper(retry + 1); }, 100);
    } else {
      console.error('Swiper CDN not loaded after waiting.');
    }
    return;
  }
  const requestedInitial = getInitialSlideFromFrameParam();
  const slideEls = document.querySelectorAll('.main-swiper .swiper-slide');
  const cappedInitial = (typeof requestedInitial === 'number' && slideEls.length > 0)
    ? Math.min(requestedInitial, slideEls.length - 1)
    : requestedInitial;

  swiper = new Swiper('.main-swiper', {
    direction: 'vertical',
    slidesPerView: 1,
    effect: 'fade',
    speed: 200,
    preloadImages: false,
    fadeEffect: {
      crossFade: true,
    },

    // Điều hướng frame CHỈ dùng trên PC (mouse wheel, xử lý bên dưới).
    // Trên mobile không chuyển frame kiểu swiper -> trang cuộn bình thường.
    allowTouchMove: false,

    lazy: {
      loadPrevNext: false,
      loadOnTransitionStart: false,
    },

    initialSlide: (typeof cappedInitial === 'number') ? cappedInitial : 0,

    on: {
      slideChangeTransitionStart() {
        const spd = (this && this.params && typeof this.params.speed === 'number') ? this.params.speed : 200;
        const el = document.querySelector('.main-swiper');
        if (el) {
          el.style.transition = `transform ${spd}ms ease`;
          el.style.willChange = 'transform';
          requestAnimationFrame(() => { el.style.transform = 'scale(1.02)'; });
        }
        $('.swiper-main').removeClass('swiper-main');
      },
      slideChangeTransitionEnd() {
        const el = document.querySelector('.main-swiper');
        if (el) el.style.transform = 'scale(1)';
      }
    }
  });

  swiper.on('slideChange', () => {
    window.dispatchEvent(new CustomEvent('main-frame-change', {
      detail: { index: swiper.activeIndex },
    }));
  });

  const containerEl = document.querySelector('.main-swiper');
  if (containerEl) {
    containerEl.dataset.swiperInitialized = '1';
    const spd = (swiper && swiper.params && typeof swiper.params.speed === 'number') ? swiper.params.speed : 200;
    containerEl.style.transition = `transform ${spd}ms ease`;
    containerEl.style.willChange = 'transform';
    // initialSlide can fire transitionStart without a matching transitionEnd,
    // leaving the whole frame at the temporary 1.02 preview scale.
    requestAnimationFrame(() => { containerEl.style.transform = 'scale(1)'; });
  }
}

window.addEventListener('main-frame-request', (event) => {
  const index = Number(event.detail && event.detail.index);
  if (!Number.isInteger(index)) return;

  // Frame 3 và 4 nằm chung trong một iframe; nav cha chỉ điều khiển panel
  // tương ứng bên trong iframe này.
  if (index === 2 || index === 3) {
    const frame = index === 3 ? 'frame4' : 'frame3';
    showCombinedFrame(frame);

    if (isMobileMainFlow()) {
      scrollMobileToCombinedFrame(frame);
      return;
    }

    if (swiper && !swiper.destroyed) {
      swiper.slideTo(Math.min(2, swiper.slides.length - 1));
    }
    return;
  }

  if (isMobileMainFlow()) {
    const frame = document.querySelector(`#frame${index + 1}`);
    if (frame) frame.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return;
  }

  if (!swiper || swiper.destroyed) return;
  swiper.slideTo(Math.max(0, Math.min(index, swiper.slides.length - 1)));
});

// Public API for scripts that need to navigate the main Swiper/nav.
// Frames are 1-based to match the labels in the navigation: 1 = Home, 4 = Cake Shop.
window.goToMainFrame = function goToMainFrame(frame) {
  const index = Number(frame) - 1;
  if (!Number.isInteger(index) || index < 0 || index > 3) return false;

  // Keep the visual nav state in sync immediately, including on mobile where
  // there is no Swiper slideChange event.
  window.dispatchEvent(new CustomEvent('main-frame-change', { detail: { index } }));
  window.dispatchEvent(new CustomEvent('main-frame-request', { detail: { index } }));
  return true;
};

// Gọi hàm khởi tạo Swiper
initMainSwiper();
bindCombinedFrameLoad();

const initialCombinedFrame = getInitialSlideFromFrameParam();
if (initialCombinedFrame === 2 || initialCombinedFrame === 3) {
  showCombinedFrame(initialCombinedFrame === 3 ? 'frame4' : 'frame3');
}

// Wheel không bubble qua boundary của iframe. Frame 3/4 sẽ relay wheel về đây
// để khi rê chuột trên nội dung iframe, Swiper chính vẫn chuyển frame như cũ.
let iframeWheelLockUntil = 0;
window.addEventListener('message', (event) => {
  if (!event.data) return;

  if (event.data.type === 'combined-frame-active' && isCombinedFrameSource(event.source)) {
    activeCombinedFrame = event.data.frame === 'frame4' ? 'frame4' : 'frame3';
    updateCombinedFrameHeight(activeCombinedFrame);

    // The combined iframe always loads on frame3 and reports that state, even
    // while the main Swiper is still on Home. Only let it control the parent
    // navigation when the parent is actually displaying the combined slide.
    const combinedSlideIndex = swiper
      ? Math.min(2, swiper.slides.length - 1)
      : -1;
    if (isMobileMainFlow() || !swiper || swiper.destroyed || swiper.activeIndex !== combinedSlideIndex) {
      return;
    }

    window.dispatchEvent(new CustomEvent('main-frame-change', {
      detail: { index: activeCombinedFrame === 'frame4' ? 3 : 2 },
    }));
    return;
  }

  if (event.data.type !== 'main-iframe-wheel') return;
  if (isMobileMainFlow() || !swiper || swiper.destroyed) return;

  const comesFromEmbeddedFrame = Array.from(document.querySelectorAll('iframe.embedded-frame'))
    .some((frame) => frame.contentWindow === event.source);
  if (!comesFromEmbeddedFrame) return;

  const deltaY = Number(event.data.deltaY);
  if (!Number.isFinite(deltaY) || Math.abs(deltaY) < 20) return;

  const now = Date.now();
  if (now < iframeWheelLockUntil) return;

  if (isCombinedFrameSource(event.source)) {
    if (deltaY > 0 && activeCombinedFrame === 'frame3') {
      showCombinedFrame('frame4');
      iframeWheelLockUntil = now + 600;
      return;
    }
    if (deltaY < 0 && activeCombinedFrame === 'frame4') {
      showCombinedFrame('frame3');
      iframeWheelLockUntil = now + 600;
      return;
    }
  }

  const speed = (swiper.params && typeof swiper.params.speed === 'number') ? swiper.params.speed : 200;
  if (deltaY > 0) swiper.slideNext(speed, true);
  else swiper.slidePrev(speed, true);
  iframeWheelLockUntil = now + 600;
});

window.addEventListener('load', function () {
  if ($('#MS__wrapper.iframe').length > 0) return;

  // Try init again in case load fires after the inline call above.
  initMainSwiper();
  if (!swiper) return;

  // ===== Faces autoplay (chỉ hoạt động nếu có .swiper-faces; guard sẵn nên vô hại) =====
  let facesAutoplayTimeout;
  let isUserInteracting = false;

  function clearFacesAutoplay() {
    if (!facesAutoplayTimeout) return;
    clearTimeout(facesAutoplayTimeout);
    facesAutoplayTimeout = null;
  }

  function scheduleFacesAutoplay() {
    clearFacesAutoplay();
    const facesSwiper = document.querySelector('.swiper-faces')?.swiper;
    if (!facesSwiper || isUserInteracting) return;
    if (!facesSwiper.slides || facesSwiper.slides.length <= 1) return;
    facesAutoplayTimeout = setTimeout(() => {
      if (document.hidden) { clearFacesAutoplay(); return; }
      if (facesSwiper && !isUserInteracting) facesSwiper.slideNext();
      scheduleFacesAutoplay();
    }, 3000);
  }

  function maybeStartFacesAutoplay() {
    if (document.hidden) return;
    scheduleFacesAutoplay();
  }

  swiper.on('touchStart', () => {
    isUserInteracting = true;
    clearFacesAutoplay();
  });
  swiper.on('touchEnd', () => {
    isUserInteracting = false;
    maybeStartFacesAutoplay();
  });
  swiper.on('slideChange', () => {
    const facesThumbSlides = document.querySelectorAll('#nth-ld-25-ld-faces .content .swiper-faces-thumb .swiper-slide');
    const isFacesSlide = swiper.activeIndex === swiper.slides.length - 2;
    facesThumbSlides.forEach(slide => {
      slide.style.pointerEvents = isFacesSlide ? 'auto' : 'none';
    });
    if (isFacesSlide) maybeStartFacesAutoplay();
    else clearFacesAutoplay();
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      clearFacesAutoplay();
    } else if (swiper && swiper.activeIndex === swiper.slides.length - 2) {
      maybeStartFacesAutoplay();
    }
  });
  window.addEventListener('beforeunload', clearFacesAutoplay);
  window.addEventListener('pagehide', clearFacesAutoplay); // iOS Safari background gesture

  // ==========================================================================
  // MOBILE: dừng ở đây. Không điều hướng frame kiểu swiper -> trang cuộn bình
  // thường (CSS đã set html.site{overflow:auto} + .main-swiper{touch-action:auto}).
  // ==========================================================================
  if (isMobileDevice()) return;

  // ===== PC ONLY: điều hướng frame bằng mouse wheel =====
  const EDGE_EPS = 2;             // dung sai mép
  const TRANSITION_LOCK = 40;     // buffer sau transitionEnd để tránh đúp

  function getScrollableAncestor(el) {
    while (el && el !== document.body && el !== document.documentElement) {
      const st = getComputedStyle(el);
      if ((st.overflowY === 'auto' || st.overflowY === 'scroll') && el.scrollHeight > el.clientHeight) {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }
  function atTop(el) {
    return !el || el.scrollTop <= EDGE_EPS;
  }
  function atBottom(el) {
    if (!el) return true;
    return el.scrollTop + el.clientHeight >= el.scrollHeight - EDGE_EPS;
  }

  // Khóa trong lúc Swiper đang transition (chống nhảy nhiều slide)
  let isSliding = false;
  swiper.on('transitionStart', () => { isSliding = true; });
  swiper.on('transitionEnd', () => { setTimeout(() => isSliding = false, TRANSITION_LOCK); });

  // ===== Main wheel: 1 cử chỉ = 1 lần chuyển frame =====
  (function setupMainWheel() {
    const root = document.querySelector('.main-swiper');
    if (!root || root._mainWheelAttached) return;
    root._mainWheelAttached = true;

    const LINE_HEIGHT = 16; // for deltaMode===1
    const MIN_ABS = 30;     // ignore tiny/noise
    const LOCK_MS = 600;    // one slide per gesture
    let lockUntil = 0;

    function normalizeDelta(e) {
      let dx = e.deltaX, dy = e.deltaY;
      if (e.deltaMode === 1) { dx *= LINE_HEIGHT; dy *= LINE_HEIGHT; }
      else if (e.deltaMode === 2) { dx *= window.innerWidth; dy *= window.innerHeight; }
      return { dx, dy };
    }

    root.addEventListener('wheel', (e) => {
      if (e.defaultPrevented) return;
      const { dx, dy } = normalizeDelta(e);
      if (Math.abs(dy) < Math.abs(dx)) return; // vertical only
      if (Math.abs(dy) < MIN_ABS) return;

      const now = Date.now();
      if (now < lockUntil || isSliding) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      // Ưu tiên cuộn nội dung bên trong frame trước
      const scrollable = getScrollableAncestor(e.target);
      if (dy > 0) {
        if (scrollable && !atBottom(scrollable)) return;
      } else {
        if (scrollable && !atTop(scrollable)) return;
      }

      if (swiper && !swiper.destroyed) {
        const spd = swiper.params && typeof swiper.params.speed === 'number' ? swiper.params.speed : 200;
        if (dy > 0) swiper.slideNext(spd, true);
        else swiper.slidePrev(spd, true);
      }
      lockUntil = now + LOCK_MS;
      e.preventDefault();
      e.stopPropagation();
    }, { passive: false });
  })();

  // ===== Nested Swiper wheel guard =====
  // Khi có Swiper lồng bên trong slide (vd faces slider ngang), dùng wheel sẽ chạy hết
  // các slide bên trong trước khi cho Swiper dọc bên ngoài chuyển frame.
  function attachInnerWheelGuard(innerEl) {
    if (!innerEl || innerEl._innerWheelGuardAttached) return;
    const innerSwiper = innerEl.swiper;
    if (!innerSwiper) return; // chưa init
    innerEl._innerWheelGuardAttached = true;
    let innerLockUntil = 0;
    let innerIsSliding = false;
    const WHEEL_LOCK = 600; // ms: một cử chỉ = 1 lần
    const LINE_HEIGHT = 16;
    const MIN_ABS = 30;

    // Smooth scale transitions for inner container
    const spdInner = (innerSwiper.params && typeof innerSwiper.params.speed === 'number') ? innerSwiper.params.speed : 200;
    innerEl.style.transition = `transform ${spdInner}ms ease`;
    innerEl.style.willChange = 'transform';
    innerSwiper.on('transitionStart', () => { innerIsSliding = true; });
    innerSwiper.on('transitionEnd', () => { innerIsSliding = false; });
    innerSwiper.on('slideChangeTransitionStart', () => {
      requestAnimationFrame(() => { innerEl.style.transform = 'scale(1.02)'; });
    });
    innerSwiper.on('slideChangeTransitionEnd', () => {
      innerEl.style.transform = 'scale(1)';
    });

    function normalizeDelta(e) {
      let dx = e.deltaX, dy = e.deltaY;
      if (e.deltaMode === 1) { dx *= LINE_HEIGHT; dy *= LINE_HEIGHT; }
      else if (e.deltaMode === 2) { dx *= window.innerWidth; dy *= window.innerHeight; }
      return { dx, dy };
    }

    innerEl.addEventListener('wheel', function (e) {
      if (!innerSwiper || innerSwiper.destroyed) return;
      const { dx, dy } = normalizeDelta(e);
      if (Math.abs(dy) < Math.abs(dx)) return; // chỉ xử lý cử chỉ theo trục dọc
      if (Math.abs(dy) < MIN_ABS) return;      // bỏ nhiễu

      const now = Date.now();
      if (now < innerLockUntil || innerIsSliding) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      const spd = (innerSwiper.params && typeof innerSwiper.params.speed === 'number') ? innerSwiper.params.speed : 200;
      // Ở trong inner, ưu tiên chạy hết inner trước khi thả cho outer
      if (dy > 0 && !innerSwiper.isEnd) { // xuống -> next
        innerSwiper.slideNext(spd, true);
        innerLockUntil = now + WHEEL_LOCK;
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      if (dy < 0 && !innerSwiper.isBeginning) { // lên -> prev
        innerSwiper.slidePrev(spd, true);
        innerLockUntil = now + WHEEL_LOCK;
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      // ở mép -> thả cho outer
    }, { passive: false });
  }

  function scanAndAttachInnerSwipers() {
    document.querySelectorAll('.main-swiper .swiper').forEach(el => {
      if (el.classList.contains('main-swiper')) return;
      attachInnerWheelGuard(el);
    });
  }
  scanAndAttachInnerSwipers();
  // Theo dõi swiper lồng phát sinh động
  const mo = new MutationObserver(() => scanAndAttachInnerSwipers());
  const mainSwiperEl = document.querySelector('.main-swiper');
  if (mainSwiperEl) {
    mo.observe(mainSwiperEl, { childList: true, subtree: true });
  }
});

// ===== PostMessage =====
window.addEventListener('message', function (e) {
  if (e.data && e.data.type === 'closePopup') {
    $('.container-iframe').removeClass('active');
  }
});

window.addEventListener('load', function () {
  $('.MS__popup-close').on('click', function () {
    sendMessageToParent({ type: 'closePopup' });
  });
});

// Đảm bảo iframe con gửi đúng thông điệp ra cha
function sendMessageToParent(message) {
  if (window.parent) {
    window.parent.postMessage(message, '*'); // '*' có thể thay bằng nguồn cụ thể nếu cần
  }
}
